var React = require('react');

function Video (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_44309","data-name":"Group 44309","transform":"translate(-2 -7.5)"},[React.createElement("path",{"id":"Path_52854","data-name":"Path 52854","d":"M26.4,30.5H5.253A3.269,3.269,0,0,1,2,27.214V10.786A3.269,3.269,0,0,1,5.253,7.5H26.4a3.269,3.269,0,0,1,3.253,3.286V27.214A3.269,3.269,0,0,1,26.4,30.5Z","fill":"#2425aa","key":0}),React.createElement("path",{"id":"Path_52855","data-name":"Path 52855","d":"M21,13.5v9.835L28.418,28.2a1.7,1.7,0,0,0,1.714.081,1.635,1.635,0,0,0,.881-1.447V10.008a1.635,1.635,0,0,0-.882-1.446,1.694,1.694,0,0,0-1.713.082Z","transform":"translate(11.987 0.581)","fill":"#2425aa","key":1})]));
}

Video.defaultProps = {"width":"41","height":"23","viewBox":"0 0 41 23"};

module.exports = Video;

Video.default = Video;
